// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__e7dHG","title":"styles_title__RFxbh","content":"styles_content__Nf3gD","error":"styles_error__arhSQ","button":"styles_button__a4L6g"};